import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQS = [
  {
    q: "Come posso modificare la mia prenotazione?",
    a: "Puoi modificare la tua prenotazione in qualsiasi momento dalla sezione \"Modifica Prenotazione\" qui sotto. Ti basterà inserire il tuo codice di prenotazione (es. LP-XXXXXXXX) ricevuto al momento della conferma. Potrai aggiornare il numero di persone, il pacchetto o i tuoi dati personali.",
  },
  {
    q: "Come posso annullare la mia prenotazione?",
    a: "Per annullare una prenotazione, contattaci direttamente al numero 351 889 2962 indicando il tuo codice di prenotazione. Ti chiediamo di comunicare la disdetta almeno 24 ore prima dell'evento. Non essendoci pagamento anticipato, non verrà addebitato nulla.",
  },
  {
    q: "Dove si parcheggia?",
    a: "La Peschiera Club dispone di un grande parcheggio esterno gratuito direttamente adiacente alla struttura. È illuminato e sorvegliato. Capienza abbondante anche per le serate più affollate. Non è necessaria la prenotazione del posto auto.",
  },
  {
    q: "Il pagamento avviene online?",
    a: "No. Il sito serve esclusivamente per prenotare il posto. Il pagamento avviene interamente in cassa all'ingresso della serata. Nessun dato di pagamento viene richiesto online.",
  },
  {
    q: "Cosa include il pacchetto 'Tavolo e Bottiglia'?",
    a: "Il pacchetto include un tavolo riservato per tutta la serata e una bottiglia a scelta tra quelle disponibili (da concordare con il personale all'ingresso). Il tavolo viene assegnato all'arrivo in base alla disponibilità.",
  },
  {
    q: "Quali sono gli orari di apertura?",
    a: "La Peschiera Club è aperta almeno 3 sere a settimana, principalmente nel fine settimana. Gli orari variano a seconda dell'evento. Consulta la sezione 'Prossimi Eventi' per date e orari aggiornati.",
  },
  {
    q: "Si accettano prenotazioni per gruppi numerosi?",
    a: "Assolutamente sì! Per gruppi superiori a 10 persone ti consigliamo di contattarci direttamente al 351 889 2962 per organizzare al meglio l'accoglienza e riservare tavoli adeguati.",
  },
  {
    q: "Come raggiungo La Peschiera Club?",
    a: "Siamo in Via Q. Sella 65, Valdengo (BI). Facilmente raggiungibile in auto. Utilizza Google Maps o Waze cercando 'La Peschiera Club Valdengo' per le indicazioni stradali più precise.",
  },
];

function FAQItem({ q, a, isOpen, onToggle }) {
  return (
    <div
      className="border-b transition-all"
      style={{ borderColor: 'rgba(255,255,255,0.08)' }}
    >
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between py-5 px-2 text-left gap-4 group"
        data-testid={`faq-${q.slice(0,20).replace(/\s/g,'-')}`}
      >
        <span className="font-playfair text-lg md:text-xl font-bold text-white group-hover:text-gold transition-colors leading-snug">
          {q}
        </span>
        <span className="shrink-0 text-gold">
          {isOpen ? <ChevronUp size={22} /> : <ChevronDown size={22} />}
        </span>
      </button>
      {isOpen && (
        <div className="px-2 pb-5 animate-fade-in">
          <p className="text-gray-300 text-lg leading-relaxed">{a}</p>
        </div>
      )}
    </div>
  );
}

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <section id="faq" data-testid="faq-section" className="py-24" style={{ background: '#070710' }}>
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="section-eyebrow">Domande frequenti</p>
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-white mb-4">
            Hai delle <span className="text-gold italic">domande?</span>
          </h2>
          <p className="text-gray-400 text-lg">Tutto quello che devi sapere prima di venire a trovarci.</p>
        </div>

        {/* Payment highlight */}
        <div
          className="flex items-center gap-4 p-5 rounded-2xl mb-10"
          style={{
            background: 'linear-gradient(135deg, rgba(201,168,76,0.12), rgba(201,168,76,0.06))',
            border: '2px solid rgba(201,168,76,0.4)',
            boxShadow: '0 0 30px rgba(201,168,76,0.1)',
          }}
        >
          <div className="text-4xl shrink-0">💵</div>
          <div>
            <p className="font-playfair text-xl font-bold text-gold">Pagamento solo in cassa</p>
            <p className="text-gray-300 text-base mt-1">
              La prenotazione online è gratuita e non richiede carte di credito. Il pagamento avviene esclusivamente all'ingresso della serata.
            </p>
          </div>
        </div>

        {/* FAQ list */}
        <div className="card-dark px-6 py-2">
          {FAQS.map((faq, i) => (
            <FAQItem
              key={i}
              q={faq.q}
              a={faq.a}
              isOpen={openIdx === i}
              onToggle={() => setOpenIdx(openIdx === i ? null : i)}
            />
          ))}
        </div>

        {/* Contact CTA */}
        <div className="text-center mt-10">
          <p className="text-gray-400 text-lg mb-4">Non hai trovato risposta alla tua domanda?</p>
          <a href="tel:+393518892962" className="btn-primary inline-flex">
            Chiamaci: 351 889 2962
          </a>
        </div>
      </div>
    </section>
  );
}
